var _ReactRenderStorage_items, _a;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { Plugin, PluginKey } from 'prosemirror-state';
import { EventEmitter } from '../../../utils/event-emitter';
export { Renderer as ReactRendererComponent } from './react';
const key = new PluginKey('reactrenderer');
export function getReactRendererFromState(state) {
    const renderer = key.getState(state);
    if (!renderer) {
        throw new Error('ReactRenderer is missing in the editor state. Probably, you forgot to use ReactRendererExtension');
    }
    return renderer;
}
export const ReactRendererExtension = (builder, renderer) => {
    builder.context.set('reactrenderer', renderer);
    builder.addPlugin(() => new Plugin({
        key,
        state: {
            init: () => renderer,
            apply: () => renderer,
        },
    }), builder.Priority.Highest);
};
export class ReactRenderStorage extends EventEmitter {
    constructor() {
        super(...arguments);
        _ReactRenderStorage_items.set(this, []);
    }
    getItems() {
        return __classPrivateFieldGet(this, _ReactRenderStorage_items, "f");
    }
    createItem(idPrefix, render) {
        const item = new ReactRenderStorage.Item(idPrefix, render, this.removeItem.bind(this));
        __classPrivateFieldGet(this, _ReactRenderStorage_items, "f").push(item);
        this.emit('update', null);
        return item;
    }
    removeItem(itemOrId) {
        if (typeof itemOrId === 'string') {
            __classPrivateFieldSet(this, _ReactRenderStorage_items, __classPrivateFieldGet(this, _ReactRenderStorage_items, "f").filter((item) => item.id !== itemOrId), "f");
        }
        else {
            __classPrivateFieldSet(this, _ReactRenderStorage_items, __classPrivateFieldGet(this, _ReactRenderStorage_items, "f").filter((item) => item !== itemOrId), "f");
        }
        this.emit('update', null);
    }
}
_ReactRenderStorage_items = new WeakMap();
ReactRenderStorage.Item = (_a = class Item extends EventEmitter {
        constructor(idPrefix, renderFn, removeFn) {
            super();
            this.id = idPrefix + Item.getNextId();
            this.renderFn = renderFn;
            this.removeFn = removeFn;
        }
        static getNextId() {
            return this.GlobalId++;
        }
        render() {
            return this.renderFn();
        }
        remove() {
            this.removeFn(this);
        }
        rerender() {
            this.emit('rerender', null);
        }
    },
    _a.GlobalId = 0,
    _a);
